import { UserProfile } from "@api/models/UserProfile";
import { TicketType } from "@share/ticketSystem/enums/TicketTypes";

export interface CommitteeViewModelInterface {
    id: string;
    title: string;
    description?: string;

    /**
     * userProfiles of members of committee
     */
    membersUserProfiles: UserProfile[];
    ticketIds: string[];

    date: string;

    company: string;
    secretary: string;
    subjectTypeText: string;
    subjectType: TicketType;

    location?: string;
    link?: string;
    isClosed?: boolean;
}

export class CommitteeViewModel {

    id: string;
    title: string;
    description?: string;
    membersUserProfiles: UserProfile[];
    ticketIds: string[];

    date: string;

    company: string;
    secretary: string;
    subjectType: TicketType;
    subjectTypeText: string;

    location?: string;
    link?: string;
    isClosed?: boolean;

    constructor(data: CommitteeViewModelInterface) {
        Object.assign(this, data);
    }
}